<template>
    <i
        class="fa fa-fw fa-info-circle tooltip-icon"
        :style="inline ? 'display: inline' : ''"
        v-tooltip.right="text">
    </i>
</template>

<style lang="scss">
.tooltip-icon {
    color: #3b73af;
    font-size: 15px;
}

.tooltip {
    display: block !important;
    z-index: 10000;
    max-width: 250px;

    .tooltip-inner {
        background: #fff;
        color: #666874;
        border-radius: 0;
        padding: 12px 12px;
        border: 1px solid #4d64ff;
        box-shadow: 0 0.19444rem 0.77778rem rgba(0, 0, 0, .2);
    }

    .tooltip-arrow {
        width: 14px;
        height: 14px;
        position: absolute;
        margin: 5px;
        z-index: 1;
        border: none;
    }

    &[x-placement^="top"] {
        margin-bottom: 10px;
        .tooltip-arrow {
            bottom: -13px;
            left: 5px;
            margin-top: 0;
            margin-bottom: 0;
            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                height: 0;
                width: 0;
                border-style: solid;
                border-width: 8px;
                border-color: #3139f2 transparent transparent;
            }
            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 1px;
                height: 0;
                width: 0;
                border-style: solid;
                border-width: 7px;
                border-color: #fff transparent transparent;
            }
        }
    }

    &[x-placement^="right"] {
        margin-left: 10px;
        .tooltip-arrow {
            left: -15px;
            top: 5px;
            margin-top: 0;
            margin-bottom: 0;
            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                height: 0;
                width: 0;
                border-style: solid;
                border-width: 8px;
                border-color: transparent #3139f2 transparent  transparent;
            }
            &::after {
                content: '';
                position: absolute;
                top: 1px;
                left: 2px;
                height: 0;
                width: 0;
                border-style: solid;
                border-width: 7px;
                border-color: transparent #fff transparent transparent;
            }
        }
    }

    &[x-placement^="bottom-start"] {
        margin-top: 10px;
        .tooltip-arrow {
            top: -15px;
            left: 5px;
            margin-top: 0;
            margin-bottom: 0;
            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                height: 0;
                width: 0;
                border-style: solid;
                border-width: 8px;
                border-color: transparent transparent #3139f2;
            }
            &::after {
                content: '';
                position: absolute;
                top: 2px;
                left: 1px;
                height: 0;
                width: 0;
                border-style: solid;
                border-width: 7px;
                border-color: transparent transparent #fff;
            }
        }
    }

    &.popover {
        .popover-inner {
            background: #fff;
            color: #666874;
            padding: 24px;
            border-radius: 5px;
            box-shadow: 0 5px 30px rgba(black, .1);
        }
        .popover-arrow {
            border-color: #4d64ff;
        }
    }

    &[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
    }

    &[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
    }
}
</style>

<script>
import { VTooltip } from 'v-tooltip'

export default {
    directives: {
        tooltip: VTooltip
    },

    props: {
        text: String,

        inline: {
            type: Boolean,
            default: false
        }
    },
}
</script>
